import axiosInstance from "api/axiosInstance"

import { monitorDashboardAction } from "./monitor-dashboard-slice"

import exportAxiosInstance from "api/exportAxiosInstance"

import FileSaver from "file-saver"

import {
  buildFlatFilterParams,
  buildFilterParams,
} from "utils/providerDashboardFilters"

const filterConfigRequestConfig = (filters, extraParams = {}) => ({
  params: {
    ...buildFilterParams(filters),
    ...extraParams,
  },
})

const extractValue = item =>
  typeof item === "object" && item !== null ? item.value : item

const convertMonitorFilters = (filters = {}) => {
  const params = {}

  const FILTER_MAP = {
    ip_ids: "ips",

    project_ids: "project",

    warehouse_ids: "warehouse",

    provider_ids: "provider",

    province_ids: "province",

    facility_ids: "facility",

    commodity_classification_ids: "commodityClassification",

    item_category_ids: "category",

    item_ids: "item",

    date_from: "from",

    date_to: "to",

    fund_codes: "fundCode",

    waybill_numbers: "waybillNumber",

    shipment_ids: "shipment",

    receipt_types: "receiptType",

    distribution_types: "distributionType",

    batch_numbers: "batchNumber",
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    )
      return

    const legacyKey = FILTER_MAP[key] || key

    if (Array.isArray(value)) {
      const extracted = value
        .map(extractValue)
        .filter(v => v != null && v !== "all")

      if (extracted.length > 0) {
        params[legacyKey] = extracted.length === 1 ? extracted[0] : extracted
      }
    } else if (typeof value === "object" && value !== null) {
      const v = extractValue(value)

      if (v != null && v !== "all") {
        params[legacyKey] = v
      }
    } else if (value !== "all") {
      params[legacyKey] = value
    }
  })

  return params
}

const dashboardRequestConfig = (filters, extraParams = {}) => ({
  params: {
    ...convertMonitorFilters(filters),

    ...extraParams,
  },
})

// Get Monitor Stock

export const getMonitorStock = params => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorStock({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-stock`, dashboardRequestConfig(params))

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorStock({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorStock({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor IPs

export const getMonitorIps = () => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorIps({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-ips`)

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorIps({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorIps({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Item Categories

export const getMonitorItemCategories =
  (commodityClassificationId = null) =>
  dispatch => {
    dispatch(
      monitorDashboardAction.setMonitorItemCategories({
        loading: true,

        error: null,

        data: null,
      })
    )

    axiosInstance

      .get(`/v1/get-monitor-itemCategories`, {
        params: commodityClassificationId
          ? { commodity_classification_id: commodityClassificationId }
          : {},
      })

      .then(respnose => {
        dispatch(
          monitorDashboardAction.setMonitorItemCategories({
            loading: false,

            error: null,

            data: respnose?.data,
          })
        )
      })

      .catch(error => {
        dispatch(
          monitorDashboardAction.setMonitorItemCategories({
            loading: false,

            error: error?.response,

            data: null,
          })
        )

        console.log(error)
      })
  }

// Get Monitor Unit Classification

export const getMonitorCommodityClassifications = () => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorCommodityClassifications({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-commodity-classifications`)

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorCommodityClassifications({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorCommodityClassifications({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Items

export const getMonitorItems = id => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorItems({
      loading: true,

      error: null,

      data: [],
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-items/${id}`)

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorItems({
          loading: false,

          error: error?.response,

          data: [],
        })
      )

      console.log(error)
    })
}

// Export Monitor Ips Stock

export const exportMonitorIpsStock = params => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorIpsStockExport({
      loading: true,

      error: null,
    })
  )

  exportAxiosInstance

    .get(`/v1/export-monitor-ips-stock`, { params: params ? params : {} })

    .then(response => {
      const dataBlob = new Blob([response?.data], {
        type: "application/pdf,",
      })

      FileSaver.saveAs(
        dataBlob,

        `Monitor-IPs-Inventory-Report-${Math.random().toString()}.xlsx`
      )

      dispatch(
        monitorDashboardAction.setMonitorIpsStockExport({
          loading: false,

          error: null,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorIpsStockExport({
          loading: false,

          error: error?.response,
        })
      )
    })
}

// Get Monitor Projects

export const getMonitorProjects = () => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorProjects({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-projects`)

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorProjects({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorProjects({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor In Items

export const getMonitorInItems = params => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorInItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-stock-ins`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorInItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorInItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Out Items

export const getMonitorOutItems = params => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorOutItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-stock-outs`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorOutItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorOutItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor IP Stock

export const getMonitorIpsStock = params => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorIpsStock({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-ips-stock`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorIpsStock({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorIpsStock({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Ips In Items

export const getMonitorIPsInItems = params => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorInItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-ips-stock-ins`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorInItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorInItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Ips Out Items

export const getMonitorIPsOutItems = params => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorOutItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-ips-stock-outs`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorOutItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorOutItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Warehouses

export const getMonitorWarehouses = () => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorWarehouses({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-warehouses`)

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorWarehouses({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorWarehouses({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Providers

export const getMonitorProviders = () => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorProviders({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-providers`)

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorProviders({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorProviders({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Fund Codes

export const getMonitorFundCodes = () => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorFundCodes({
      loading: true,
      error: null,
      data: null,
    })
  )

  axiosInstance
    .get(`/v1/get-monitor-fund-codes`)
    .then(response => {
      dispatch(
        monitorDashboardAction.setMonitorFundCodes({
          loading: false,
          error: null,
          data: response?.data,
        })
      )
    })
    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorFundCodes({
          loading: false,
          error: error?.response,
          data: null,
        })
      )
      console.log(error)
    })
}

// Get Monitor Shipments

export const getMonitorShipments = () => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorShipments({
      loading: true,
      error: null,
      data: null,
    })
  )

  axiosInstance
    .get(`/v1/get-monitor-shipments`)
    .then(response => {
      dispatch(
        monitorDashboardAction.setMonitorShipments({
          loading: false,
          error: null,
          data: response?.data,
        })
      )
    })
    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorShipments({
          loading: false,
          error: error?.response,
          data: null,
        })
      )
      console.log(error)
    })
}

// Get Monitor Provider Users

export const getMonitorProviderUsers = ip_id => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorProviderUsers({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-provider-users/${ip_id}`)

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorProviderUsers({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorProviderUsers({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Provinces

export const getMonitorProvinces = () => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorProvinces({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-provinces`)

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorProvinces({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorProvinces({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Facilities

export const getMonitorFacilities = id => dispatch => {
  dispatch(
    monitorDashboardAction.setMonitorFacilities({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-monitor-facilities/${id}`)

    .then(respnose => {
      dispatch(
        monitorDashboardAction.setMonitorFacilities({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        monitorDashboardAction.setMonitorFacilities({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Monitor Dashboard Filter Config

export const fetchMonitorDashboardConfig =
  (filters = {}, isCascadeRefresh = false) =>
  (dispatch, getState) => {
    if (isCascadeRefresh) {
      const existing =
        getState().monitorDashboard.monitorDashboardConfig?.data ?? null
      dispatch(
        monitorDashboardAction.setMonitorDashboardConfig({
          loading: true,
          error: null,
          data: existing,
        })
      )
    } else {
      dispatch(
        monitorDashboardAction.setMonitorDashboardConfig({
          loading: true,
          error: null,
          data: null,
        })
      )
    }

    axiosInstance

      .get(
        `/v1/get-monitor-dashboard-config`,
        filterConfigRequestConfig(filters)
      )

      .then(response => {
        dispatch(
          monitorDashboardAction.setMonitorDashboardConfig({
            loading: false,

            error: null,

            data: response?.data?.data,
          })
        )
      })

      .catch(error => {
        dispatch(
          monitorDashboardAction.setMonitorDashboardConfig({
            loading: false,

            error: error?.response,

            data: null,
          })
        )
      })
  }

// Fetch Monitor Section Chart Data (bar, line, pie, stackedBar)

export const fetchMonitorSectionChartData =
  ({ filters = {}, section, chartType, dataset = "stock" } = {}) =>
  dispatch => {
    if (!section || !chartType) return

    dispatch(
      monitorDashboardAction.setSectionChartData({
        section,

        loading: true,

        error: null,

        data: null,

        hasData: false,
      })
    )

    const params = dashboardRequestConfig(filters, { dataset })

    axiosInstance

      .get(`/v1/get-monitor-chart-data/${chartType}`, params)

      .then(response => {
        const payload = response?.data?.data || {}

        dispatch(
          monitorDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: null,

            data: payload.data || [],

            dataset,

            hasData: Boolean(payload.has_data),
          })
        )
      })

      .catch(error => {
        dispatch(
          monitorDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: error?.response,

            data: null,

            hasData: false,
          })
        )
      })
  }

export const exportMonitorRealtimeDashboard =
  ({ filters = {}, dataset = "stock", format = "xlsx" } = {}) =>
  dispatch => {
    dispatch(
      monitorDashboardAction.setRealtimeExportState({
        loading: true,
        error: null,
      })
    )

    const exportParams = dashboardRequestConfig(filters, { dataset })

    return exportAxiosInstance

      .get(`/v1/monitor/dashboard/export/${format}`, {
        ...exportParams,

        responseType: "blob",
      })

      .then(response => {
        const extension =
          format === "csv" ? "csv" : format === "pdf" ? "pdf" : "xlsx"

        const mimeType =
          format === "csv"
            ? "text/csv"
            : format === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

        FileSaver.saveAs(
          new Blob([response.data], { type: mimeType }),

          `monitor-dashboard-${dataset}.${extension}`
        )

        dispatch(
          monitorDashboardAction.setRealtimeExportState({
            loading: false,
            error: null,
          })
        )

        return Promise.resolve()
      })

      .catch(error => {
        dispatch(
          monitorDashboardAction.setRealtimeExportState({
            loading: false,

            error: error?.response,
          })
        )

        return Promise.reject(error)
      })
  }

// Fetch Monitor Section Map Data

export const fetchMonitorSectionMapData =
  ({ filters = {}, type = "receipt" } = {}) =>
  dispatch => {
    const section = "map"

    dispatch(
      monitorDashboardAction.setSectionChartData({
        section,

        loading: true,

        error: null,

        data: null,

        hasData: false,
      })
    )

    axiosInstance

      .get(
        `/v1/get-monitor-province-map/${type}`,
        dashboardRequestConfig(filters)
      )

      .then(response => {
        const payload = response?.data?.data || {}

        dispatch(
          monitorDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: null,

            data: payload,

            type,

            hasData: Boolean(payload.has_data),
          })
        )
      })

      .catch(error => {
        dispatch(
          monitorDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: error?.response,

            data: null,

            hasData: false,
          })
        )
      })
  }
